<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data Inicial"
                v-model="dt_emi_ini"
                class="form-control"
                :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
                locale="pt-br"
                reset-button
                placeholder="Data Fim"
                v-model="dt_emi_fim"
                class="form-control"
                :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="num_carga"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Numero de carga
                <span
                    v-b-tooltip
                    title="Para filtrar multiplas cargas separe as cargas por vírgulas"
                >[?]</span>
              </label
              >
            </div>
          </b-col>
          <b-col sm="4" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="observacao"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Observacao</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
                v-model="regiao"
                :options="this.$parent.optionsRegiao"
                track-by="value"
                label="label"
                :limit="10"
                :multiple="true"
                :clear-on-select="false"
                :hide-selected="true"
                placeholder="Região"
                tag-placeholder=""
                select-label=""
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
                v-model="unidade"
                :options="this.$parent.optionsPessoaParceira"
                track-by="value"
                label="label"
                placeholder="Unidade/Parceiro Destino"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                :hide-selected="true"
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="p-a-0 m-t-5px">
            <multiselect
                v-model="status_processo_expedicao"
                :options="this.$parent.optionsStatusProcessoExpedicao"
                track-by="value"
                label="label"
                placeholder="Processo Expedição"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                :hide-selected="true"
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="4" class="p-a-0 m-t-5px">
            <multiselect
                v-model="transportadora"
                :options-limit="300"
                :limit="2"
                :limit-text="limitText"
                :options="optionsTransportadora"
                track-by="value"
                label="label"
                id="transportadora"
                :hide-selected="true"
                placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingTransportadora"
                @search-change="listaTransportadora"
            ></multiselect>
          </b-col>
          <b-col md="4" class="p-0">
            <multiselect
                v-model="redespacho"
                :options-limit="300"
                :limit="10"
                :multiple="true"
                :limit-text="limitText"
                :options="optionsRedespacho"
                track-by="value"
                label="label"
                id="redespacho"
                :hide-selected="true"
                placeholder="Redespacho ( Digite 3 caracteres para pesquisar )"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
                :searchable="true"
                :loading="isLoadingRedespacho"
                @search-change="listaRedespacho"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="6" class="p-a-0 m-t-5px">
            <b-form-checkbox
                v-model="consulta_completa"
                value="1"
                unchecked-value="2"
            >
              Consulta Completa
              <span
                  v-b-tooltip
                  title="Se marcado irá retornar consulta completa da carga"
                  placement="top"
              >[?]</span
              >
            </b-form-checkbox>
          </b-col>
          <b-col sm="6" md="2">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="doFilter"
                    :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                    type="button"
                    class="btn btn-secondary btn-outline"
                    @click="resetFilter"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from 'moment'
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({
        params: [],
        search: "",
      }),
      isLoadingTransportadora: false,
      transportadora: [],
      optionsTransportadora: [],
      dt_emi_ini: "",
      consulta_completa: "",
      dt_emi_fim: "",
      observacao: "",
      dt_emi_ini_label: '',
      dt_emi_fim_label: '',
      status_processo_expedicao: '',
      num_carga: "",
      redespacho: [],
      isLoadingRedespacho: false,
      optionsRedespacho: [],
      unidade: [],
      regiao: [],
      optionsUnidade: [],
      data_filter: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
  },
  methods: {
    doFilter() {
      if (!this.hasRequiredFilters()) {
        return this.showWarning("Informe ao menos um filtro para realizar a busca.");
      }
      this.$store.commit("setVuetableFilterButton", true);
      this.array_redespacho = [];
      this.array_regiao = [];
      this.dt_emi_ini_label = this.dt_emi_ini;
      this.dt_emi_fim_label = this.dt_emi_fim;
      this.dt_emi_ini = this.formatDateSubmit(this.dt_emi_ini);
      this.dt_emi_fim = this.formatDateSubmit(this.dt_emi_fim);
      if(this.redespacho.length > 0) {
        this.redespacho.forEach((obj) => {
          this.array_redespacho.push(obj.value)
        });
      }
      if(this.regiao.length > 0) {
        this.regiao.forEach((obj) => {
          this.array_regiao.push(obj.value)
        });
      }
      this.data_filter = {
        observacao: this.observacao,
        dt_emi_ini: this.dt_emi_ini,
        dt_emi_fim: this.dt_emi_fim,
        num_carga: this.num_carga,
        consulta_completa: this.consulta_completa,
        transportadora: this.transportadora,
        unidade: this.unidade,
        redespacho: this.array_redespacho,
        regiao: this.array_regiao,
        status_processo_expedicao: this.status_processo_expedicao,
      };
      this.$events.fire("filter-set", this.data_filter);
      this.dt_emi_ini = this.dt_emi_ini_label;
      this.dt_emi_fim = this.dt_emi_fim_label;
    },
    resetFilter() {
      this.dt_emi_ini = "";
      this.observacao = "";
      this.dt_emi_fim = "";
      this.num_carga = "";
      this.unidade = "";
      this.regiao = "";
      this.redespacho = "";
      this.consulta_completa = "";
      this.status_processo_expedicao = "";
      this.transportadora = "";
      this.$events.fire("filter-reset");
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
              this.optionsTransportadora = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
                response.items.forEach((obj) => {
                  this.optionsTransportadora.push({
                    label:
                        "PJ -" +
                        obj.pessoa.cd +
                        " - " +
                        obj.razao_social +
                        " - " +
                        this.onFormataCnpj(
                            obj.cnpj_base,
                            obj.cnpj_filial,
                            obj.cnpj_digito
                        ).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") +
                        " - " +
                        obj.inscricao_estadual,
                    pessoa_id: obj.pessoa_id,
                    value: this.onFormataCnpj(
                        obj.cnpj_base,
                        obj.cnpj_filial,
                        obj.cnpj_digito
                    ),
                  });
                });
              }
              if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                  this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.cpf,
                  });
                });
              }
              if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                  this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.cuit,
                  });
                });
              }
              this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
            });
      }
    },
    listaRedespacho(search) {
      if (search.length >= 3) {
        this.isLoadingRedespacho = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
            .post("/api/pessoa/jsonlist/fornecedor")
            .then((response) => {
              this.optionsRedespacho = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
                response.items.forEach((obj) => {
                  this.optionsRedespacho.push({
                    label:
                        "PJ -" +
                        obj.pessoa.cd +
                        " - " +
                        obj.razao_social +
                        " - " +
                        this.onFormataCnpj(
                            obj.cnpj_base,
                            obj.cnpj_filial,
                            obj.cnpj_digito
                        ) +
                        " - " +
                        obj.inscricao_estadual,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                  this.optionsRedespacho.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                  this.optionsRedespacho.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                  });
                });
              }
              this.isLoadingRedespacho = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
            });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado
      var pad = "00000000";
      var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000"
      var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
      var pad = "00"
      var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
          ? ''
          : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
    hasRequiredFilters() {
      return [
        this.observacao,
        this.dt_emi_fim,
        this.num_carga,
        this.unidade,
        this.regiao,
        this.redespacho,
        this.consulta_completa,
        this.status_processo_expedicao,
        this.transportadora,
      ].some(value => Array.isArray(value) ? value.length > 0 : !!value);
    },
    showWarning(message) {
      this.$Simplert.open({
        title: "Atenção",
        message,
        customCloseBtnText: "Fechar",
        type: "warning",
      });
    },
  },
  computed: {
    vuetableFilterButton() {
      return !this.hasRequiredFilters();
    }
  },
};
</script>
